// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "WPCloud",
    appLogoImage: require("@src/assets/images/liscr_logo.png"),
    successStatusImage: require("@src/assets/images/success_status.png"),
    errorStatusImage: require("@src/assets/images/error_status.png"),
    ziploader: require("@src/assets/images/loader.gif")
  },
  navicons: {
    home1: require("@src/assets/images/nav_icons/menu_icons/home_01.png"),
    home2: require("@src/assets/images/nav_icons/menu_icons/home_02.png"),

    Money1: require("@src/assets/images/nav_icons/menu_icons/currency_01.png"),
    Money2: require("@src/assets/images/nav_icons/menu_icons/currency_02.png"),

    company1: require("@src/assets/images/nav_icons/menu_icons/company_01.png"),
    company2: require("@src/assets/images/nav_icons/menu_icons/company_02.png"),

    price1: require("@src/assets/images/nav_icons/menu_icons/price_01.png"),
    price2: require("@src/assets/images/nav_icons/menu_icons/price_02.png"),

    product1: require("@src/assets/images/nav_icons/menu_icons/product_01.png"),
    product2: require("@src/assets/images/nav_icons/menu_icons/product_02.png"),

    role1: require("@src/assets/images/nav_icons/menu_icons/role_01.png"),
    role2: require("@src/assets/images/nav_icons/menu_icons/role_02.png"),

    invoice1: require("@src/assets/images/nav_icons/invoice1.png"),
    invoice2: require("@src/assets/images/nav_icons/invoice2.png"),

    financialreport1: require("@src/assets/images/nav_icons/financial-report1.png"),
    financialreport2: require("@src/assets/images/nav_icons/financial-report2.png"),

    dashboard: require("@src/assets/images/nav_icons/dashboard_icon.png"),
    dashboard1: require("@src/assets/images/nav_icons/dashboard_icon.png"),

    Search: require("@src/assets/images/nav_icons/search_icon.png"),
    Search1: require("@src/assets/images/nav_icons/search_icon.png"),

    library: require("@src/assets/images/nav_icons/folder_icon1.png"),
    library1: require("@src/assets/images/nav_icons/folder_icon1.png"),

    subscriptions: require("@src/assets/images/nav_icons/rlm_icon1.png"),
    subscriptions1: require("@src/assets/images/nav_icons/rlm_icon1.png"),

    Profile: require("@src/assets/images/nav_icons/account_icon.png"),
    Profile1: require("@src/assets/images/nav_icons/account_icon.png"),

    appSettings: require("@src/assets/images/nav_icons/appSettings.png"),
    appSettings1: require("@src/assets/images/nav_icons/appSettings_01.png"),

    dlibrary: require("@src/assets/images/nav_icons/folder_black.png"),
    logout: require("@src/assets/images/navicons/user_profile.png"),
    notification: require("@src/assets/images/navicons/notification.svg"),
    user: require("@src/assets/images/navicons/user_profile.png"),

    rotate: require("@src/assets/images/nav_icons/rotate-right.png"),
    more: require("@src/assets/images/nav_icons/more.png"),
    rotate1: require("@src/assets/images/nav_icons/rotate_right1.png"),
    more1: require("@src/assets/images/nav_icons/more1.png"),
    invoice: require("@src/assets/images/invoice.png"),
    Right_Tick: require("@src/assets/images/nav_icons/Right_Tick.png"),
    waypoint: require("@src/assets/images/nav_icons/waypoint.png"),
    peopleOutline: require("@src/assets/images/nav_icons/people-outline.png"),
    cloudOutline: require("@src/assets/images/nav_icons/cloud-outline.png"),
    billing: require("@src/assets/images/nav_icons/billing.png")
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
